<template>
  <div class="charge-edit">
    <div class="row">
      <div class="label">{{ $t('lang.Equipment Number') }}</div>
      <div class="row-right">
        {{ itemInfo.number}}
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Equipment Type') }}</div>
      <div class="row-right">
        {{ $t('lang.E-Motorcycle') }}
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Central Control Number') }}</div>
      <div class="row-right">
        {{ itemInfo.udid }}
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.ECU Manufacturer') }}</div>
      <div class="row-right">
        <el-select
          v-model="itemInfo.controllerManufacturerNo"
          placeholder="请选择厂商">
          <el-option
            v-for="(item,key) in deviceManufacturerList"
            :key="item.number"
            :label="item.name"
            :value="item.number">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Vehicle Spec') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="itemInfo.specification"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Vehicle Frame Number') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="itemInfo.frameNo"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.License Plates') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="itemInfo.vinNo"></el-input>
      </div>
    </div>
    <!--<div class="row">
      <div class="label">{{ $t('lang.Equipment State') }}</div>
      <div class="row-right">
        <el-select
          disabled
          v-model="itemInfo.statusCode">
          <el-option
            v-for="(item,key) in deviceStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>-->
    <div class="row">
      <div class="label">{{ $t('lang.Equipment Photo') }}</div>
      <div class="image-box">
        <div class="image-item">
          <div class="image-title">{{ $t('lang.Front View') }}</div>
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-success="handleAvatarSuccess0"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="pictures.picture0" :src="pictures.picture0" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div class="image-item">
          <div class="image-title">{{ $t('lang.Side View') }}</div>
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="pictures.picture1" :src="pictures.picture1" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div class="image-item">
          <div class="image-title">{{ $t('lang.Back View') }}</div>
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="pictures.picture2" :src="pictures.picture2" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="normal-btn" @click="cancel">取消</div>
      <div class="blue-btn ml24"  @click="confirm">确认</div>
    </div>
  </div>
</template>
<script>
import {editThailandElectricBicycle, queryElectricBicyclePicture} from '../../api/deviceManagement';

export default {
  name: 'electricBicycleMgmtEditView',
  props: {
    deviceStatusList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      //上传限制
      limitCount: 1,
      itemInfo: {},
      deviceManufacturerList:{},
      pictures: {
        picture0: '',
        picture1: '',
        picture2: '',
      },
      pictureForm: {

      },
      //是否正在编辑的标志
      isEditLoadingFlag: false,
    };
  },
  watch: {
    editData: {
      handler(newVal) {
        this.itemInfo = JSON.parse(JSON.stringify(newVal))
        this.queryElectricBicyclePicture()
      },
      deep: true,
    },
  },
  mounted() {
    this.queryAllManufacturer();
  },
  methods: {
    async handleAvatarSuccess0(res, file) {
      this.pictures.picture0 = await this.toBase64(file.raw);
    },
    async handleAvatarSuccess1(res, file) {
      this.pictures.picture1 = await this.toBase64(file.raw);
    },
    async handleAvatarSuccess2(res, file) {
      this.pictures.picture2 = await this.toBase64(file.raw);
    },
    queryAllManufacturer() {
      let params = {
        controllerManufacturerNo: this.itemInfo.controllerManufacturerNo,
      };
        this.$http
          .post("/managementPlatform/electricity/queryDeviceManufacturerInfo",this.$qs.stringify(params))
          .then(response => {
            let res = response.data;
            if (!res || !res.result) {
              this.$message({
                type: "error",
                message: res.message || "select fail",
                center: true
              });
              return;
            }
            this.deviceManufacturerList = res.ldata
          })
          .catch(err => {
            console.log(err);
          });
      },
    beforeAvatarUpload(file) {
      if(file.size/1024/1024 > 2) {
        alert(this.$t('lang.Please upload pictures below 2m'))
        return false
      }
      return true
    },
    /**
     * 返回base64
     */
    async toBase64(item) {
      let reader = new FileReader();
      reader.readAsDataURL(item);
      let self = this;
      let result = null
      result = await new Promise((resolve, reject) => {
        reader.onloadend = () => {
          resolve(reader.result)
        }
      })
      return result
    },
    /**
     * 取消，退回列表
     */
    cancel() {
      this.$emit('cancel')
    },
    /**
     * 获取电动车图片
     * @returns {Promise<void>}
     */
    async queryElectricBicyclePicture() {
      const params = {
        number: this.itemInfo.number
      }
      const res = await queryElectricBicyclePicture(params)
      this.pictures = {
        picture0: res.mdata.picture0.picture_0,
        picture1: res.mdata.picture1.picture_1,
        picture2: res.mdata.picture2.picture_2
      }
    },
    /**
     * 点击确定
     */
    confirm() {
      let self = this;
      this.$confirm(this.$t('Are you sure to submit?'), "", {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        type: "warning"
      }).then(() => {
        // 转base64
        for (const picturesKey in self.pictures) {
          console.log(self.pictures[picturesKey])
          if(self.pictures[picturesKey]) {
            self.pictureForm[picturesKey] = self.pictures[picturesKey]
          } else {
            self.pictureForm[picturesKey] = ''
          }
        }
        setTimeout(() => {
          self.editThailandElectricBicycle();
        }, 500)
      }).catch(action => {

      });
    },
    /**
     * 编辑电动车信息
     */
    async editThailandElectricBicycle() {
      if(this.isEditLoadingFlag) {
        this.$message.warning(this.$t('In operation') + '...')
        return
      }
      const params = {
        number: this.itemInfo.number,
        vinNo: this.itemInfo.vinNo,
        frameNo: this.itemInfo.frameNo,
        specification: this.itemInfo.specification,
        // status: this.itemInfo.statusCode,
        controllerManufacturerNo: this.itemInfo.controllerManufacturerNo,
        ...this.pictureForm
      }
      params.picture0 && (params.type0 = params.picture0.split(';')[0].split('/')[1])
      params.picture1 && (params.type1 = params.picture1.split(';')[0].split('/')[1])
      params.picture2 && (params.type2 = params.picture2.split(';')[0].split('/')[1])
      params.picture0 && (params.picture0 = params.picture0.split(',')[1])
      params.picture1 && (params.picture1 = params.picture1.split(',')[1])
      params.picture2 && (params.picture2 = params.picture2.split(',')[1])
      try {
        this.isEditLoadingFlag = true
        await editThailandElectricBicycle(params)
        this.isEditLoadingFlag = false
        this.$message.success(this.$t('lang.Successful'))
        setTimeout(() => {
          this.$emit('cancel')
        }, 1500)
      } catch (e) {
        this.isEditLoadingFlag = false
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.row {
  display: flex;
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .image-box {
    display: flex;
    .image-item {
      margin-right: 20px;
      .image-title {
        margin-bottom: 20px;
      }
    }
  }
  .row-right {
    display: inline-block;
    line-height: 30px;

    .img-box {
      display: inline-block;
    }

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 250px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 920px;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .btn {
    cursor: pointer;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}


.avatar {
  width: 200px;
  height: 150px;
  display: block;
}
.hide-upload /deep/ .el-uploadel-upload--picture-card {
  display: none; /* 上传按钮隐藏 */
}

.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/electricBicycleEditView.vue